const envConfig = {
  API_URL: import.meta.env.VITE_API_URL || "http://localhost:3000/api/v1",
  API_URL_BASED: import.meta.env.VITE_API_URL_BASED || "http://localhost:3000",
  REDUX_STORAGE_SECRET_KEY: import.meta.env.VITE_REDUX_STORAGE_SECRET_KEY || "default_secret",
  TIMEZONE: import.meta.env.VITE_TZ || "UTC",
  NODE_ENV: import.meta.env.VITE_NODE_ENV || "production",
  LOADING_TIMEOUT_MS: Number(import.meta.env.VITE_LOADING_TIMEOUT_MS) || 40000,
};

export default envConfig;
